import Link from "../Link";
import React from "react";

const AsideMenu = (props) => {

    const menu = props.data.menu,
        list = menu.map((item) => {
            return <li key={item.key} className={"nav-item" + (item.key === props.data.activeMenu ? " active" : "")}>
                <Link data={{
                    type: item.type,
                    className: item.className,
                    href: item.href,
                    label: <>{item.label} <span></span></>,
                    attributes: item.attributes,
                    handleClick: props.handleClick,
                }} />
            </li>
        })
    ;

    return (
        <ul className="navbar-menu">
            {list}
        </ul>
    );
};

export default AsideMenu;